import Vue from 'vue'
import App from './App.vue'
import { store } from './store.js'
import router from './router'
import firebase from 'firebase'
import VueCookies from 'vue-cookies'
import VueMeta from 'vue-meta'
import Notifications from 'vue-notification';
import VueSocialSharing from 'vue-social-sharing';
import vuetify from './plugins/vuetify';

// import MediaEmbed from '@ckeditor/ckeditor5-media-embed/src/mediaembed';
Vue.use(VueSocialSharing);
import Verte from 'verte'
import VueCountdownTimer from 'vuejs-countdown-timer';

Vue.use(VueCountdownTimer);
Vue.use(VueMeta, {
  keyName: 'metaInfo',
  attribute: 'data-vue-meta',
  ssrAttribute: 'data-vue-meta-server-rendered',
  tagIDKeyName: 'vmid',
  refreshOnceOnNavigation: true
})
Vue.use(Notifications)
Vue.use(VueCookies)
Vue.use(Verte)
Vue.use(require('vue-moment'));

const fb = require('./firebaseConfig.js')


// set default config
VueCookies.config('7d')
Vue.config.productionTip = false
firebase.auth().onAuthStateChanged(user => {
  if (user) {
    store.commit('setCurrentUser', user)
    store.dispatch('fetchUserProfile')
  
  } else {
    store.dispatch('clearData')
  }

  new Vue({
    store,
    router,
    vuetify,
    render: h => h(App),
  }).$mount('#app')
  
})

